import { render, staticRenderFns } from "./AppInputFile.vue?vue&type=template&id=8b4fd38c&scoped=true&"
import script from "./AppInputFile.vue?vue&type=script&lang=js&"
export * from "./AppInputFile.vue?vue&type=script&lang=js&"
import style0 from "./AppInputFile.vue?vue&type=style&index=0&id=8b4fd38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4fd38c",
  null
  
)

export default component.exports